import { render, staticRenderFns } from "./NormalInvoice.vue?vue&type=template&id=0b7f0212&scoped=true&"
import script from "./NormalInvoice.vue?vue&type=script&lang=ts&"
export * from "./NormalInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./NormalInvoice.vue?vue&type=style&index=0&id=0b7f0212&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7f0212",
  null
  
)

export default component.exports